import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, useEffect, useState } from "react";
import { LuImagePlus } from "react-icons/lu";
import {
  addCompanyProfileDetails,
  updateCompanyProfileDetails,
} from "../../../../api/company.api";
import { baseURL } from "../../../../api/api";
import { success } from "../../../../utils/notifications";

const initialData = {
  logo: "",
  name: "",
  email: "",
  phone: "",
  address: "",
  website: "",
  description: "",
};
const CompanyDetailsPopup = ({
  open,
  setOpen,
  mode,
  companyDetails,
  fetchCompanyProfile,
}) => {
  const [companyDetailsData, setCompanyDetailsData] = useState(initialData);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (mode === "edit") {
      setCompanyDetailsData(companyDetails);
    } else {
      setCompanyDetailsData(initialData);
    }
  }, [mode, companyDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompanyDetailsData({
      ...companyDetailsData,
      [name]: value,
    });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
    console.log("image is", file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("logo", selectedImage);
    formData.append("name", companyDetailsData.name);
    formData.append("email", companyDetailsData.email);
    formData.append("phone", companyDetailsData.phone);
    formData.append("address", companyDetailsData.address);
    formData.append("description", companyDetailsData.description);

    console.log(formData);
    for (var pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }
    if (mode === "edit") {
      updateCompanyProfileDetails(companyDetails._id, formData)
        .then((res) => {
          console.log(res.data);
          setOpen(false);
          success("Updated", "Company Details updated Successfully");
          fetchCompanyProfile();
        })
        .catch((err) => {
          console.log("Error updating company details", err);
        });
    } else {
      addCompanyProfileDetails(formData)
        .then((res) => {
          console.log(res.data);
          setOpen(false);
          success("Added", "Company Details Added Successfully");
          fetchCompanyProfile();
        })
        .catch((err) => {
          console.log("Error adding company details", err);
        });
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="z-50" onClose={setOpen}>
        <Transition.Child
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-300"
          leaveFrom="opacity-100 transform scale-100"
          leaveTo="opacity-0 transform scale-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-500"
              enterFrom="opacity-0 transform scale-0"
              enterTo="opacity-100 transform scale-100"
              leave="ease-in duration-300"
              leaveFrom="opacity-100 transform scale-100"
              leaveTo="opacity-0 transform scale-0"
            >
              <Dialog.Panel className="mt-12 lg:ml-60 md:ml-60 ml-0 z-50 lg:w-1/2 md:w-1/2 w-4/5 fixed mx-auto rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all h-auto">
                <div className="absolute top-0 right-0 pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="">
                  <div className=" sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="px-3 pb-5 text-xl font-semibold border-b-2 border-gray-200 leading-6 text-gray-900"
                    >
                      Company Information
                    </Dialog.Title>
                    <div className="">
                      <form onSubmit={handleSubmit} method="POST">
                        <div className="h-96 overflow-y-scroll">
                          <div className="px-7 py-4">
                            <div className="flex items-center justify-between">
                              <div>
                                <h2 className="text-xl font-semibold text-gray-300 ">
                                  Company Details
                                </h2>
                              </div>
                            </div>
                            <div className="py-3 md:py-4 lg:py-4">
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="companyLogo"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Logo
                                  </label>
                                </div>
                                <div className="text-left lg:col-span-7 md:col-span-7 sm:col-span-12">
                                  <div className="w-1/3 mt-2 ">
                                    <label
                                      htmlFor="logo"
                                      className="mx-auto bg-gray-100 rounded-full h-28 w-28 inset-0 flex items-center justify-center cursor-pointer"
                                    >
                                      {selectedImage ||
                                      (mode === "edit" &&
                                        companyDetails.logo) ? (
                                        <img
                                          src={
                                            selectedImage
                                              ? URL.createObjectURL(
                                                  selectedImage
                                                )
                                              : `${baseURL}/s3/images/${companyDetails.logo}`
                                          }
                                          alt="Selected"
                                          className="rounded-full h-full w-full object-cover"
                                        />
                                      ) : (
                                        <LuImagePlus className="text-gray-400 h-14 w-14 p-2" />
                                      )}
                                    </label>
                                    <input
                                      type="file"
                                      name="logo"
                                      id="logo"
                                      className="hidden"
                                      onChange={handleImageChange}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-start grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="name"
                                    className="mt-2 block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Name
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="name"
                                      placeholder="Enter Company Name"
                                      value={companyDetailsData.name}
                                      onChange={handleChange}
                                      id="name"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-start grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="phone"
                                    className="mt-2 block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Phone
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="phone"
                                      placeholder="Enter Company Phone"
                                      value={companyDetailsData.phone}
                                      onChange={handleChange}
                                      id="phone"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-start grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="email"
                                    className="mt-2 block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Email
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="email"
                                      name="email"
                                      placeholder="Enter Company Email"
                                      value={companyDetailsData.email}
                                      onChange={handleChange}
                                      id="email"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-start grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="website"
                                    className="mt-2 block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Website
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="website"
                                      placeholder="Enter Company Website"
                                      value={companyDetailsData.website}
                                      onChange={handleChange}
                                      id="website"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-start grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="address"
                                    className="mt-2 block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Company Address
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="address"
                                      placeholder="Enter Company Address"
                                      value={companyDetailsData.address}
                                      onChange={handleChange}
                                      id="address"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-start grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="description"
                                    className="mt-2 block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Description
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <textarea
                                      type="text"
                                      name="description"
                                      placeholder="Enter Company description"
                                      value={companyDetailsData.description}
                                      onChange={handleChange}
                                      id="description"
                                      className="text-sm font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-300 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                                      required
                                      rows={4}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-t-2 border-gray-200 px-7 pt-3 flex items-center justify-end">
                          <button
                            type="submit"
                            className="flex justify-center rounded-md bg-yellow py-2.5 px-8 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                          >
                            {mode === "edit" ? "Update" : "Save"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default CompanyDetailsPopup;
